<div class="service-title service-title-bg bg-3" *ngIf="false">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="service-title-text">
                    <h2>{{product.titre}}</h2>
                    <ul>
                        <li>
                            <a routerLink="/">Home</a>
                        </li>
                        <li>
                            <i class="icofont-rounded-double-right"></i>
                            <a routerLink="/products">Products</a>
                        </li>
                        <li>
                            <i class="icofont-rounded-double-right"></i>
                            {{product.titre}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="service-details-area main-service-area pt-100 services-details-page">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <!-- style="max-height:600px" -->
                <img [src]="product.image" alt="product">
                <div class="service-details-post">
                    <h3>{{product.titre}}</h3>
                    <div [innerHTML]="product.description">
                    </div>
                </div>
            </div>

            <div class="col-lg-4 main-service-area blog-side-bar">
                <div class="service-sidebar">
                    <div class="service-list">
                        <p>Categories</p>
                        <ul>
                            <li *ngFor="let produit of products|keyvalue" [ngClass]="{'active':produit.key==currentProduct}">
                                <a routerLink="/products/{{produit.value.url}}">
                                    <img src="assets/img/produit/{{produit.value.src}}" class="icon-size mr-1" alt="produit">
                                    {{produit.value.titre}}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
